import { render, staticRenderFns } from "./EShop.vue?vue&type=template&id=3a0fa10d&scoped=true&"
import script from "./EShop.vue?vue&type=script&lang=js&"
export * from "./EShop.vue?vue&type=script&lang=js&"
import style0 from "./EShop.vue?vue&type=style&index=0&id=3a0fa10d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0fa10d",
  null
  
)

export default component.exports